import React, { useEffect, useState } from "react";
import { Modal, Image, Form } from "react-bootstrap";
import { Icon } from "@iconify/react";
import bathroomIcon from "../assets/img/bathroomIcon.png";
import homeIcon from "../assets/img/homeIcon.png";
import compliantIcon from "../assets/img/compliantIcon.png";
import interiordesignerIcon from "../assets/img/interior-designerIcon.png";
import paymentIcon from "../assets/img/paymentIcon.png";
import { Link } from "react-router-dom";
import projectDescIcon from "../assets/img/projectDescIcon.png";
import { revokePreviewUrls } from "../utils/photoPreview";
import { ClickablePhoto, usePhotoLightbox } from "./PhotoLightbox";

const BathroomModal = ({ Bathroom, BathroomToggle, StepcompleteNext }) => { 
  const [step, setStep] = useState(1);
  const [selected, setSelected] = useState(0);
  const [responses, setResponses] = useState({}); // Store "yes"/"no" responses per step
  const [errorMessage, setErrorMessage] = useState("");
  const [uploadErrorMessage, setUploadErrorMessage] = useState("");
  const [fileUploads, setFileUploads] = useState([]); // Store uploaded files per step
  const [filePreviews, setFilePreviews] = useState([]); // Store file previews per step
  const totalSteps = 6;
  const [isNextDisabled, setIsNextDisabled] = useState(true);
  const [description, setDescription] = useState("");
  const [descriptionError, setDescriptionError] = useState(false);
  const { openLightbox, closeLightbox } = usePhotoLightbox();
  // Handle next button click
  useEffect(() => {
    setIsNextDisabled(!responses[step]); // Disable if no response exists
  }, [step, responses]);
  const handleNext = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!responses[step]) {
      setErrorMessage("Please select an option.");
      return;
    } else {
      setErrorMessage("");
    }

    // Check for file upload validation if "Yes" is selected
    if (step== 2 && responses[step] === "yes" && (!fileUploads[step] || fileUploads[step].length === 0)) {
      setUploadErrorMessage("Please upload at least one file.");
      return;
    } else {
      setUploadErrorMessage("");
    }

    if (step < totalSteps) {
      setStep((prevStep) => prevStep + 1);
    }
  };
  const submitFormDetail = () => {
    StepcompleteNext(responses,fileUploads,description);
  }
  const handleRemoveImage = (stepNumber, index) => {
    setFilePreviews((prev) => {
      const current = prev[stepNumber] || [];
      const removed = current[index];
      if (removed) revokePreviewUrls([removed]);

      const updatedPreviews = current.filter((_, i) => i !== index);
      return {
        ...prev,
        [stepNumber]: updatedPreviews.length ? updatedPreviews : undefined,
      };
    });

    setFileUploads((prev) => {
      const current = prev[stepNumber] || [];
      const updatedFiles = current.filter((_, i) => i !== index);
      return {
        ...prev,
        [stepNumber]: updatedFiles.length ? updatedFiles : undefined,
      };
    });

    setUploadErrorMessage("Please upload at least one image.");
  };

  const assignArchitecturalFiles = (selectedFiles) => {
    if (!selectedFiles.length) return;

    setUploadErrorMessage("");
    const previews = selectedFiles.map((file) => URL.createObjectURL(file));

    setFileUploads((prev) => ({
      ...prev,
      0: selectedFiles,
      [step]: selectedFiles,
    }));

    setFilePreviews((prev) => ({
      ...prev,
      [step]: previews,
    }));
  };

  const handleDropArchitectural = (event) => {
    event.preventDefault();
    const files = Array.from(event.dataTransfer.files).filter((file) =>
      file.type.startsWith("image/")
    );
    assignArchitecturalFiles(files);
  };

  // Handle file change
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    assignArchitecturalFiles(selectedFiles);
    e.target.value = "";
  };

  // Handle Yes/No button click
  const handleYesNoClick = (choice) => {
    setSelected(1);
    setErrorMessage("");
    
    var question = "";
    if(step == 1) {
      question = "Master Bathroom (if applicable)";
    }
    if(step == 2) {
      question = "Architectural Plans or Drawings";
    }
    if(step == 3) {
      question = "Building Permit";
    }
    if(step == 4) {
      question = "Working with a Designer";
    }
    if(step == 5) {
      question = "Selling the Home";
    }
    setIsNextDisabled(false);
    setResponses((prevResponses) => ({
      ...prevResponses,
      [step]: choice,
      [question]:choice
    }));
    
  };

  const handleBathroomClose = () => {
    closeLightbox();
    revokePreviewUrls(Object.values(filePreviews).flat().filter(Boolean));
    setStep(1);
    setResponses({});
    BathroomToggle();
    setFileUploads([]);
    setFilePreviews([]);
    setIsNextDisabled(false);
  };

  return (
    <>
    <Modal show={Bathroom} onHide={handleBathroomClose} centered className="modal-getstarted">
      <button
        type="button"
        className="rs-lc-close"
        onClick={handleBathroomClose}
        aria-label="Close"
      >
        <Icon icon="tabler:x" width={22} height={22} />
      </button>
      <Modal.Body className="text-center rs-lc-body">
        {/* Progress Bar */}
        <div className="peronalInfoProgress mb-4">
          {[...Array(totalSteps)].map((_, index) => (
            <span
              key={index}
              className={index < step ? "done" : ""}
              onClick={() => {
                if (index + 1 < step) {
                  setStep(index + 1);
                }
              }}
              style={{ cursor: index + 1 < step ? "pointer" : "default" }}
            ></span>
          ))}
        </div>

        {/* Steps Content */}
        {[
          { text: "Is this your master bathroom?", icon: bathroomIcon },
          { text: "Do you have architectural plans or drawings?", icon: homeIcon },
          { text: "Do you already have a building permit?", icon: compliantIcon },
          { text: "Are you working with a designer?", icon: interiordesignerIcon },
          { text: "Will you be selling this home?", icon: paymentIcon },
          { text: "Provide a brief description of your project.", icon: projectDescIcon },
        ].map((item, index) => (
          <div key={index} className={`personalInfosteps ${step === index + 1 ? "d-block" : "d-none"}`}>
            <h4>Tell Us About Your Project</h4>
            <Image className="personalIcon" src={item.icon} alt="" />
            <h3>{item.text}</h3>

            {/* Yes/No Buttons */}
            {step !== 6 &&
            <div className="yesnobtn_box mb-4">
            <Link
              className={`yesnobtn ${responses[step] === "yes" ? "active" : ""}`}
              onClick={() => handleYesNoClick("yes")}
            >
              Yes
            </Link>
            <Link
              className={`yesnobtn ${responses[step] === "no" ? "active" : ""}`}
              onClick={() => handleYesNoClick("no")}
            >
              No
            </Link>
          </div>
          }

            {/* Error Messages */}
            {errorMessage && <div className="text-danger">{errorMessage}</div>}

            {/* File Upload Field - Only show if "Yes" is selected */}
            {step == 2 && responses[step] === "yes" && !filePreviews[step]?.length && (
              <div
                className="additional-div rs-re-upload-zone mt-2"
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleDropArchitectural}
              >
                <Form.Label htmlFor={`uploadphotos-${step}`}>
                  <Icon icon="garden:upload-fill-16" width={24} height={24} />
                  <h6>Upload photos</h6>
                  <p className="mb-0">Drag and drop here, or click to browse</p>
                </Form.Label>
                <Form.Control
                  required
                  type="file"
                  accept="image/png,image/jpeg,image/webp,image/heic"
                  name="uploadphotos"
                  id={`uploadphotos-${step}`}
                  className="d-none"
                  onChange={handleFileChange}
                />
              </div>
            )}

            {/* Upload Error Message */}
            {uploadErrorMessage && <div className="text-danger mb-3">{uploadErrorMessage}</div>}

            {/* File Previews */}
            {step == 2 && responses[step] === "yes" && filePreviews[step] && filePreviews[step].length > 0 && (
              <div className="file-previews mt-3 rs-re-preview-grid">
                {filePreviews[step].map((src, index) => (
                  <div key={src} className="preview-container uploadRemove_box rs-re-step-preview">
                    <ClickablePhoto
                      src={src}
                      alt={`Architectural plan preview ${index + 1}`}
                      onView={openLightbox}
                    />
                    <button
                      type="button"
                      className="close-preview"
                      onClick={() => handleRemoveImage(step, index)}
                      aria-label="Remove photo"
                    >
                      <Icon icon="tabler:x" width={18} height={18} />
                    </button>
                  </div>
                ))}
                <p className="rs-re-upload-confirm">Photo uploaded — click to view full size, or tap × to replace</p>
              </div>
            )}
            { step === 6 && (
              <Form className="text-start mt-2">
                <Form.Group className="form-group">
                  <Form.Label>Write here</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    isInvalid={descriptionError}
                  />
                  <Form.Control.Feedback type="invalid">
                    Description is required.
                  </Form.Control.Feedback>
                </Form.Group>
              </Form>
            )}
          </div>
        ))}

        {/* Buttons */}
        <div className="d-flex align-items-center justify-content-center gap-2 flex-wrap mt-4">
          {step < totalSteps ? (
            <Link 
            className={`nextmodal_btn ${isNextDisabled ? "disabled" : ""}`} 
            onClick={handleNext}
            style={{ pointerEvents: isNextDisabled ? "none" : "auto", opacity: isNextDisabled ? 0.5 : 1 }}
          >
            Next <Icon icon="mynaui:arrow-right" width="24" height="24" />
          </Link>
          ) : (
            <Link className="nextmodal_btn" onClick={submitFormDetail}>
              Next <Icon icon="mynaui:arrow-right" width="24" height="24" />
            </Link>
          )}
        </div>
      </Modal.Body>
    </Modal>
    </>
  );
};

export default BathroomModal;
